<section class="blank-page">
  <div class="card container">
    <div class="container__heading">

      <div class="card-header border-0">
        <div class="card-title text-center">
          <img src="../../../../assets/app-assets/images/logo/logo-b-geia.png" width="150px" alt="geia logo">
        </div>
      </div>
      <h2>Géia Consultoria e Corretora de Seguros </h2>
      <h4 class="mt-2">Política de Privacidade de Dados</h4>

    </div>
    <div class="container__content">
      <ol>
        <li><strong>1.Propósito, escopo </strong></li>
      </ol>
      <p>O objetivo dessa Política é informar a maneira como realizamos o tratamento e coleta de dados pessoais e de
        saúde.
        Como a Géia respira a cultura da privacidade e proteção de dados pessoais, podemos informar que &nbsp; estamos a
        par da Lei Geral
        de Proteção de Dados Pessoais (“LGPD”), das boas práticas de governança &nbsp; em privacidade sugeridas pelos
        órgãos
        de controle e associações técnico-profissionais, e principalmente: temos o compromisso de transparência.</p>

      <ol start="2">
        <li><strong>2.Documentos de referência </strong></li>
        <ul>
          <li class="closed">Inciso I do artigo 7º e 14 da Lei nº 13.709/18);</li>
          <li class="closed">Inciso II do artigo 7º da Lei nº 13 .709/18); </li>
          <li class="closed">Inciso VI do artigo 7º da Lei nº 13.709/18); </li>
          <li class="closed">Inciso V do artigo 7º da Lei nº 13.709/18);</li>
          <li class="closed">Inciso IX do artigo 7º da Lei nº 13.709/18). </li>
        </ul>
      </ol>

      <ol>
        <li><strong>3.Glossário </strong></li>
      </ol>
      <p><strong>Dado pessoal:</strong> informação relacionada a pessoa natural identificada ou identificável; </p>
      <p>Leads para prospecção comercial;</p>
     <p><strong>Dado de saúde:</strong> informação coletada à compra de plano de saúde e questionário para programa de saúde. </p>
     <p><strong>Titular:</strong> Pessoa natural a quem se referem os dados pessoais que são objeto de tratamento;  </p>
     <p><strong>Dependentes:</strong> pessoas que fazem parte da relação de dependentes do produto adquirido pelo titular;  </p>
     <p><strong> Controlador:</strong> pessoa natural ou jurídica, de direito público ou privado, a quem competem as decisões referentes ao tratamento de dados pessoais; </p>
     <p><strong> Operador:</strong>Pessoa natural ou jurídica, de direito público ou privado, que realiza o tratamento de dados pessoais em nome do controlador;  </p>
     <p><strong> Tratamento:</strong> toda operação realizada com dados pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração; </p>
     <p><strong> Consentimento:</strong> Manifestação livre, informada e inequívoca pela qual o titular concorda com o tratamento de seus dados pessoais e de saúde, para uma finalidade determinada; </p>
     <p><strong> Anonimização:</strong> Utilização de meios técnicos razoáveis e disponíveis no momento do tratamento, por meio dos quais um dado perde a possibilidade de associação, direta ou indireta, a um indivíduo;  </p>

      <ol start="3">
        <li><strong>4. Titulares dos Dados e forma de coleta </strong></li>
      </ol>
      <ol start="3">
        <li class="sub-list"><strong>4.1 Titulares </strong></li>
      </ol>
      <p>Coletamos e tratamos todos os dados pessoais e de saúde fornecidos por nossos clientes. Todos os dados coletados são estritamente necessários e adequados para atingir uma finalidade legítima, sobretudo para prestação do serviço contratado, seja este cadastral, consultivo, análise, atuarial, judicial ou extrajudicial. </p>
      
      <ol start="3">
        <li class="sub-list"><strong>4.2 Forma de coleta  </strong></li>
      </ol>
      <p><strong>Recebemos dados pessoais dos seguintes titulares: </strong></p>

      <ul>
        <li class="closed">Inciso VI do artigo 7º da Lei nº 13.709/18); </li>
        <li class="closed">Contrato de prestação de serviços firmado;                       </li>
        <li class="closed">Cotação de planos via Website. </li>
        <li class="closed">Contrato de Plano de Saúde e Odontológico e de Ramos Elementares;</li>
        <li class="closed">Formulário eletrônico via website. </li>
        <li class="closed">Questionário de Saúde; </li>
        <li class="closed">(Contratantes titulares e dependentes); </li> 
        <li class="closed">Colaboradores e Fornecedores (Política interna própria). </li>
      </ul>
       
      <ol start="4">
        <li><strong>5. Como utilizamos os dados </strong></li>
      </ol>
      <p>Nos dados pessoais coletados é realizado o tratamento das suas informações de acordo com as seguintes finalidades específicas:</p>
    <p> Necessário para prestar o serviço contratado; </p>
    <p> Prospectar novos clientes; </p>
    <p> Análise de saúde, envio de dados a Operadora do plano de Saúde e programas de saúde;</p>
    <p> Defender os interesses da empresa em processo judicial ou administrativo.</p>
    <p>rigação Legal, como, por exemplo, para fins tributários; responder às solicitações de autoridades por ordens judiciais; </p> 
    <p>Responder solicitações ou enviar informações administrativas;  </p> 
    <p> Promover a coleta de dados médicos dos clientes (Contratantes), para envio á Operadora, para a elaboração de relatórios de sinistralidade, oferta de programas de qualidade de vida e dados atuariais para controle econômico/financeiro dos contratos firmados com operadoras de plano de saúde. </p>
      
    <ol start="5">
        <li><strong>6. Fundamento legal para tratamento de seus dados pessoais </strong></li>
      </ol>
      <p>A legislação que permite e controla esse ato é a Lei 13.709/2018, ou Lei Geral de Proteção de Dados. Com o advento da respectiva Lei, apenas podemos tratar seus dados pessoais para as finalidades que indicamos acima no item V, as quais se amoldam às seguintes autorizações legais: </p>
       
      <p>Execução do contrato, ou de procedimentos preliminares relacionados ao contrato do cliente (inciso V do artigo 7º da Lei nº 13.709/18); </p>
      <p>Obrigação legal ou regulatória (inciso II do artigo 7º da Lei nº 13.709/18);  </p>
      <p>Legítimo interesse para apoio e promoção comercial (inciso IX do artigo 7º da Lei nº 13.709/18); </p>
      <p>Consentimento, para os que fornecem os dados via website (inciso I do artigo 7º e 14 da Lei nº 13.709/18);  </p>
      <p>Defesa e utilização em processos judiciais (inciso VI do artigo 7º da Lei nº 13.709/18); </p>
      <p>Em caso de dúvidas sobre as bases legais para coleta, tratamento e armazenamento de seus dados pessoais, entre em contato com a Géia e seu Data Protection Officer por meio do e-mail <strong>dpo@geia.com.br.</strong> </p>
     
      <ol start="7">
        <li><strong>7. Duração do tratamento de dados pessoais </strong></li>
      </ol>
      <p>Os dados pessoais coletados ou tratados pelo escritório serão armazenados por prazo indeterminado mesmo após o término relação contratual e descartado somente se interesse do titular, nesse último caso relacionado ao recebimento de mensagens eletrônicas; </p>
      <p>Os dados pessoais tratados pela empresa serão mantidos por prazo indeterminado mesmo após o término de seu tratamento, no âmbito e nos limites técnicos das atividades, autorizada a conservação para as seguintes finalidades: </p>
      <p>Cumprimento de obrigação legal ou regulatória;  </p>
      <p>Estudo por órgão de pesquisa ou para fins estatísticos ou de gestão da empresa/controlador, sendo nesses casos sempre mediante Anonimização dos dados; </p>
      <p></p>
      <ol start="8">
        <li><strong>8. Compartilhamento de dados pessoais </strong></li>
      </ol>
      <p>Alguns dados pessoais coletados dos usuários (titular dos dados) poderão ser utilizados em plataformas de processamento (operador), permanecendo sempre a empresa como controladora dos dados pessoais. </p>
      <p>Ressaltamos, no entanto, que os seus dados nunca serão transferidos para terceiros sem uma autorização específica. Portanto, ao utilizá-los em plataformas de terceiros, (operadores) exigimos desses o mesmo padrão de segurança e garantias como clausulas de confidencialidades. </p>
      <p>Importante salientar que os dados médicos coletados são armazenados seguindo as diretrizes do Conselho Federal de Medicina e as regras insculpidas no Código de Ética Médica. </p>
       
      <ol start="9">
        <li><strong>9. Canal de comunicação </strong></li>
      </ol>
      <p>Para quaisquer informações, inclusive para exercício dos seus direitos como titular dos dados pessoais, você poderá entrar em contato, através do telefone (11) 3660-2025, ou nos enviar uma mensagem no e-mail <strong>dpo@geia.com.br.</strong>  </p>
       
    </div>
    <!-- <div class="container__nav">
      <a class="button btn btns btn-success btn-round box-shadow-4 " href="#"> <i class="fa white fa-thumbs-up"></i>
        OK</a>
    </div> -->
  </div>
</section>